import { getTeamUrl } from 'Common';

export default () => async (dispatch, getState) => {

  const { id } = getState().screens.ValuationView.valuation;

  window.location = getTeamUrl(`valuations/${id}/excel`, 'exports');

}